import styled from "@emotion/styled";
import { Panel } from "./Panel";

export const CardTitle = styled.h3<{ danger?: boolean }>`
  margin-bottom: 15px;
  color: ${({ danger }) => danger ? "#dc3545" : "#333"};
`;

export const CardContainer = styled(Panel)``;

export type CardProps = {
  danger?: boolean
  title?: string
  children: React.ReactNode
}

export function Card({ title, danger, children }: CardProps) {
  return <CardContainer>
    {title && <CardTitle danger={danger}>{title}</CardTitle>}
    {children}
  </CardContainer>
}